import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '1rem'
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1rem',
    height: '1.5rem',

    '& > *': {
      height: '100%'
    }
  },

  input: {
    border: `1px solid ${theme.palette.primary.main}`,
    boxSizing: 'border-box',
    outline: 'none',
    padding: '0 0.5rem',
    width: '100%',
    fontSize: theme.size.sm
  },

  fields: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: theme.size.sm
  },

  infoText: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.textLightFaded
  },

  field: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.5rem',
    gap: '0.5rem',
    userSelect: 'none',

    '&:last-child': {
      marginBottom: '0'
    }
  }
}))

export default useStyles
